import { REGEX_NOT_NUMBERS } from "@/core/utils/constants";
import { Directive, ElementRef, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[app-input-numbers]',
    standalone: false,
})
export class InputNumbersDirective {
    
    constructor(private el: ElementRef,
                private ctrl: NgControl) {
    }

    @HostListener('keypress', ['$event'])
    onKeyUp(event: KeyboardEvent): void {
        setTimeout(() => {
            var text: string = this.el.nativeElement.value;
            this.ctrl.control?.setValue(text?.replace(REGEX_NOT_NUMBERS, ''));
        }, 100);
    }

}